import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=2a0de155&"
import script from "./dynamics.vue?vue&type=script&lang=js&"
export * from "./dynamics.vue?vue&type=script&lang=js&"
import style0 from "./dynamics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports